import React from 'react';

// Maps backend shorthand to your SVG file naming convention
const SUIT_MAP = { S: 'spades', H: 'hearts', D: 'diamonds', C: 'clubs' };
const RANK_MAP = {
  '2': '2', '3': '3', '4': '4', '5': '5', '6': '6',
  '7': '7', '8': '8', '9': '9', '10': '10',
  'J': 'jack', 'Q': 'queen', 'K': 'king', 'A': 'ace'
};

export default function CardComponent({ card, playable, onClick, inTrick, faceDown }) {
  if (!card && !faceDown) return null;

  // Build the exact filename
  let fileName = 'back.svg'; // Default to card back
  if (!faceDown && card) {
    const rankStr = RANK_MAP[card.rank];
    const suitStr = SUIT_MAP[card.suit];
    fileName = `${rankStr}_of_${suitStr}.svg`;
  }

  const cls = [
    'card-svg',
    'card-image', // Critical: Connects to the absolute sizing failsafes in Cards.css
    playable ? 'playable' : '',
    inTrick ? 'in-trick' : '',
    faceDown ? 'face-down' : ''
  ].filter(Boolean).join(' ');

  return (
    <img
      src={`/assets/cards/${fileName}`}
      alt={faceDown ? 'Card face down' : `${card?.rank} of ${card?.suit}`}
      className={cls}
      onClick={playable && onClick ? onClick : undefined}
      style={{
        /* THE FIX: Removed inline maxWidth so Cards.css can dynamically scale 
           the cards based on 28 vs 56 mode and their location on the board. */
        width: '100%',
        height: 'auto',
        display: 'block',
        borderRadius: '6px',
        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        cursor: playable ? 'pointer' : 'default',
        border: playable ? '2px solid #6ee7b7' : '2px solid transparent',
      }}
    />
  );
}